import { Box, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { cssVars } from "./resourceDashboardTypes"

type UsageBarProps = Readonly<{
    // 0–100; clamped by the caller.
    fillPct: number
    color: string
    valueLabel?: string
}>

type StyleProps = Readonly<{ color: string }>

const useStyles = makeStyles<StyleProps>()((theme, { color }) => ({
    root: {
        display: "flex",
        gap: ".75rem",
        alignItems: "center",
        width: "100%",
    },
    track: {
        flex: 1,
        height: ".8125rem",
        borderRadius: ".1875rem",
        overflow: "hidden",
        backgroundColor: theme.palette.tailwind.slate[200],
    },
    fill: {
        height: "100%",
        width: "var(--usage-fill-width)",
        backgroundColor: color,
    },
    value: {
        width: "3.5rem",
        textAlign: "right",
        fontSize: ".875rem",
        fontVariantNumeric: "tabular-nums",
        color: theme.palette.tailwind.slate[600],
    },
}))

export function UsageBar({ fillPct, color, valueLabel }: UsageBarProps) {
    const { classes } = useStyles({ color })
    const clamped = Math.min(Math.max(fillPct, 0), 100)

    return (
        <Box className={classes.root}>
            <Box className={classes.track}>
                <Box className={classes.fill} style={cssVars({ "--usage-fill-width": `${clamped}%` })} />
            </Box>
            {valueLabel !== undefined && (
                <Typography variant="caption" className={classes.value}>
                    {valueLabel}
                </Typography>
            )}
        </Box>
    )
}
